/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportsRequestGenerate } from '../../models/auth-supports-request-generate';
import { FileDownloadResponse } from '../../models/file-download-response';

export interface GenerateAuthSupportsRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * Options and data for document
     */
    body: AuthSupportsRequestGenerate
}

export function generateAuthSupportsRequest(http: HttpClient, rootUrl: string, params: GenerateAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
  const rb = new RequestBuilder(rootUrl, generateAuthSupportsRequest.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileDownloadResponse>;
    })
  );
}

generateAuthSupportsRequest.PATH = '/custom/auth-supports-requests/{uid}/generate';
